'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { InfoSection } from '@/features/client/ContactUs/components/InfoSection/InfoSection';
import { Map } from '@/features/client/ContactUs/components/Map/Map';
import { RequestFormMain } from '@/features/client/Forms/RequestFormMain/RequestFormMain';
const ContactUsPage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Contact Us"
          title="Interested in a service? Contact us!"
          description="We stay in touch with our customers until the job is complete.
For a free quote, questions, or special requests, just reach out to us."
        />
      </MainSectionLayout>
      <Section styles={{ paddingTop: 20 }}>
        <Container>
          <InfoSection />
        </Container>
      </Section>
      <Section variant="secondary">
        <Map>
          <Container>
            <RequestFormMain />{' '}
          </Container>
        </Map>
      </Section>
    </div>
  );
};

export default ContactUsPage;
